(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header-announcements"] && !Shopify.designMode) return;
  try {
    
  class FitmentMobileAnnouncements extends HTMLElement {
    currentIndex = 0;
    timer;

    connectedCallback() {
      this.slides = [...this.querySelectorAll('[data-mobile-announcement-slide]')];
      this.dots = [...this.querySelectorAll('[data-mobile-announcement-dot]')];
      this.interval = Number(this.dataset.interval) || 5000;
      this.autoplay = this.dataset.autoplay === 'true';
      this.mobileMedia = window.matchMedia('(max-width: 1199px)');
      this.dots.forEach((dot, index) => dot.addEventListener('click', () => this.show(index, true)));
      this.addEventListener('touchstart', this.handleTouchStart, { passive: true });
      this.addEventListener('touchend', this.handleTouchEnd, { passive: true });
      this.addEventListener('mouseenter', this.stop);
      this.addEventListener('mouseleave', this.start);
      this.addEventListener('focusin', this.stop);
      this.addEventListener('focusout', this.start);
      document.addEventListener('visibilitychange', this.handleVisibility);
      this.mobileMedia.addEventListener('change', this.handleMediaChange);
      this.handleMediaChange();
    }

    disconnectedCallback() {
      this.stop();
      this.removeEventListener('touchstart', this.handleTouchStart);
      this.removeEventListener('touchend', this.handleTouchEnd);
      document.removeEventListener('visibilitychange', this.handleVisibility);
      this.mobileMedia.removeEventListener('change', this.handleMediaChange);
    }

    show(index, restart = false) {
      this.currentIndex = (index + this.slides.length) % this.slides.length;
      this.slides.forEach((slide, slideIndex) => {
        const active = slideIndex === this.currentIndex;
        slide.setAttribute('aria-hidden', String(!active));
        slide.tabIndex = active ? 0 : -1;
      });
      this.dots.forEach((dot, dotIndex) => dot.setAttribute('aria-current', String(dotIndex === this.currentIndex)));
      if (restart) {
        this.stop();
        this.start();
      }
    }

    start = () => {
      if (!this.autoplay || this.timer || this.slides.length < 2 || document.hidden || !this.mobileMedia.matches) return;
      this.timer = window.setInterval(() => this.show(this.currentIndex + 1), this.interval);
    };

    stop = () => {
      window.clearInterval(this.timer);
      this.timer = undefined;
    };

    handleVisibility = () => {
      if (document.hidden) this.stop();
      else this.start();
    };

    handleMediaChange = () => {
      this.stop();
      if (!this.mobileMedia.matches) return;
      this.show(0);
      this.start();
    };

    handleTouchStart = (event) => {
      const touch = event.touches[0];
      this.touchStartX = touch.clientX;
      this.touchStartY = touch.clientY;
    };

    handleTouchEnd = (event) => {
      if (this.touchStartX === undefined || this.touchStartY === undefined) return;
      const touch = event.changedTouches[0];
      const distanceX = touch.clientX - this.touchStartX;
      const distanceY = touch.clientY - this.touchStartY;
      this.touchStartX = undefined;
      this.touchStartY = undefined;
      if (Math.abs(distanceX) < 40 || Math.abs(distanceX) <= Math.abs(distanceY)) return;
      this.show(this.currentIndex + (distanceX < 0 ? 1 : -1));
    };
  }

  if (!customElements.get('fitment-mobile-announcements')) {
    customElements.define('fitment-mobile-announcements', FitmentMobileAnnouncements);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
